export default '/build/1420d038.svg'